import React from 'react';
import type {Table} from '@tanstack/react-table';
import {IndeterminateCheckbox} from '@touchnet/react-table';

interface ComponentProps<T> {
    table: Table<T>;
}

const ColumnSelectHeader = <T,>({table}: ComponentProps<T>): JSX.Element => (
    <div className="form-check">
        <IndeterminateCheckbox
            className="form-check-input"
            type="checkbox"
            id="select-deselect-all"
            checked={table.getIsAllRowsSelected()}
            indeterminate={table.getIsSomeRowsSelected()}
            onChange={table.getToggleAllRowsSelectedHandler()}
        />
        <label className="form-check-label" htmlFor="select-deselect-all">
            <span className="visually-hidden">
                Select/Deselect All
            </span>
        </label>
    </div>
);

export default ColumnSelectHeader;
